import * as $ from 'jquery';
import 'jquery-colorbox';

export default class LightboxFormBusiness {

	//private target = document.querySelector('.productGroup--hasMakesbridgeForm--business');
	private target = document.getElementById('__BMS_FORM_ID__kzaqwLc26Hh17Da20Mi21kvfre');

	private intersectionCallback(visible:boolean) {
		function getCookie(name: string) {
			let dc = document.cookie;
			let prefix = name + "=";
			let begin = dc.indexOf("; " + prefix);
			if (begin == -1) {
				begin = dc.indexOf(prefix);
				if (begin != 0) return null;
			} else {
				begin += 2;
				var end = document.cookie.indexOf(";", begin);
				if (end == -1) {
					end = dc.length;
				}
			}
			return decodeURI(dc.substring(begin + prefix.length, end));
		}

		function setCookie(name: string, value: string, expires: number) {
			let maxAge = "max-age=" + expires;
			document.cookie = name + "=" + value + "; " + maxAge + "; path=/";
		}

		if (visible) {
			let handler = ()=> {
				setCookie('business-pop-up', 'hasBeenSeen', (8 * 60 * 60));
				$.colorbox({
					transition: 'elastic',
					opacity: .60,
					width: '93%',
					maxWidth: '600',
					maxHeight: '93%',
					fixed: true,
					close: '<span>Close</span>',
					inline: true,
					href: "#__BMS_FORM_ID__kzaqwLc26Hh17Da20Mi21kvfre",
					onComplete: () => {
						$.colorbox.resize();
						document.querySelector('html').classList.toggle('lockScroll');
						// set cookie to never expire if submitted (this for the Business makesbride form)
						$('#BMS_SUBMIT').on('click', function() {
							setCookie('business-pop-up', 'hasBeenSeen', (1 * 365 * 24 * 60 * 60));
						});
					},
					onCleanup: () => {
						document.querySelector('html').classList.toggle('lockScroll');
					}
				})
			};
			var myCookie = getCookie("business-pop-up");
			// console.log('myCookie:' , myCookie);

			if (myCookie == null) {
				window.setTimeout(handler,3000);
			}
		}
	}

	constructor() {
		if(!this.target) {
			return;
		}

		// Observing HTML tag so we didn't have to rewrite the whole thing.
		let element = document.querySelector('html');

		let observer = new IntersectionObserver(entries => {
			this.intersectionCallback(entries[0].isIntersecting);

			if (entries[0].isIntersecting) {
				observer.unobserve(this.target);
			}
		}, {threshold: .125});

		observer.observe(element);
	}
}